<div class="container content-box offset-md-4 col-md-4">
  <div>
    @if (!demandeValide) {
      <div>
        @if (tokenInvalide) {
          <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.TOKEN_INVALIDE' | translate}}</div>
        }
        @if (usernameInvalide) {
          <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.USERNAME_INVALIDE' | translate}}</div>
        }
        @if (emailDejaConfirme) {
          <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.MAIL_DEJA_CONFIRME' | translate}}</div>
        }
        @if (!tokenInvalide && !usernameInvalide && !emailDejaConfirme) {
          <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.ERREUR_GENERIQUE' | translate}}</div>
        }
        <button class="btn btn-primary" [routerLink]="''">
          {{ 'CREER_MOT_DE_PASSE.ALLER_ACCUEIL' | translate }}
        </button>
      </div>
    }
    @if (demandeValide) {
      <div>
        @if (!mdpValide) {
          <h3>{{'CREER_MOT_DE_PASSE.TITRE' | translate}}</h3>
          <form (ngSubmit)="onSubmit()">
            <input type="email" class="form-control" [value]="username" name="username" autocomplete="username" hidden disabled>
            <div class="form-group">
              <label for="password">{{'GLOBAL.MOT_DE_PASSE' | translate}}</label>
              <input type="password" class="form-control" [(ngModel)]="motDePasse" name="password" autocomplete="new-password">
              @if (mdpRequis) {
                <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.MDP_REQUIS' | translate}}</div>
              }
              @if (mdpLongMini) {
                <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.MDP_LONG_MINI' | translate}}</div>
              }
            </div>
            <div class="form-group">
              <label for="password">{{'GLOBAL.CONFIRMER' | translate}}</label>
              <input type="password" class="form-control" [(ngModel)]="motDePasseConf" name="passwordConf" autocomplete="new-password">
              @if (mdpDifferents) {
                <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.MDP_DIFFERENTS' | translate}}</div>
              }
              @if (erreurValidation) {
                <div class="custom-alert custom-alert-sm">{{'CREER_MOT_DE_PASSE.ERREUR_VALIDATION' | translate}}</div>
              }
            </div>
            <button type="submit" class="btn btn-outline-success btn-block">{{'GLOBAL.CONFIRMER' | translate}}</button>
          </form>
        }
      </div>
    }
  </div>
</div>
